// extracted by mini-css-extract-plugin
export default {"dialog":"Y9_qTNiofbUKi88C","subHeader":"EG6iGBTY5dk2Sy1J","group":"uKHnzeYuBEwWFA2Y","groupItem":"hj2ypYwCT1w4m1DI","another":"B2En8bEf4eEctYVP"};